var map = {
	"./chapelhill-logo-dark.png": "14e1",
	"./chatham-logo-dark.png": "9878",
	"./cms-logo-dark.png": "23f1",
	"./durham-logo-dark.png": "efa1",
	"./foodforstudents-logo-dark.png": "9635",
	"./johnston-logo-dark.png": "3a42",
	"./mff-logo-dark.png": "fb2f",
	"./roanoke-logo-dark.png": "bff7",
	"./wake-logo-dark.png": "c5a4"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "7507";